
import Vue from 'vue'
import { mapState } from 'vuex'
import { minLength, required, sameAs } from 'vuelidate/lib/validators'
import { email } from 'vuelidate-cyrillic-email-validator'
import Loader from '../../components/Loader.vue'
// import Wizard from '@/components/wizards/Wizard.vue'
import { userLogout, updateUser } from '@/connectors/user'
import { ModalIds } from '@/components/popup/modal-ids'

export default Vue.extend({
  name: 'Account',
  components: { Loader },
  data () {
    return {
      ModalIds,
      loading: false,
      isRegister: false,
      editUser: { ...this.$store.state.profile.user },
      password: '',
      passwordConfirmation: ''
    }
  },
  computed: {
    ...mapState({
      user: (state: any) => state.profile.user
    })
  },
  watch: {
    user: function (val) {
      this.editUser = { ...val }
    }
  },
  mounted () {
    if (this.$route.query.registered) {
      console.log(this.$route.query.registered)
      this.toggleRegister()
    }
  },
  methods: {
    toggleRegister () {
      this.isRegister = !this.isRegister
      if (!this.isRegister) {
        console.log('remove wizard')
        localStorage.removeItem('wizard')
      }
    },
    updateProfile (user) {
      // Переменная чтобы клонировать объект в нужными полями
      let cloneUser
      this.$v.$touch()
      if (this.$v.$error) {
        return
      }
      this.loading = true
      // Если пароль введен, то добавляем к объекту
      if (this.password.length || this.passwordConfirmation.length) {
        user.password = this.password
        user.passwordConfirmation = this.passwordConfirmation
      }
      // Если почта не изменялась, то не отправляем ее
      if (user.email === this.user.email) {
        cloneUser = Object.assign({}, user, { email: undefined })
      } else cloneUser = user
      updateUser(cloneUser).then(response => {
        this.$store.dispatch('profile/setUser', response)
        this.loading = false
        console.log(response)
      }).catch(e => {
        this.loading = false
        console.error(e.response)
        // @ts-ignore
        this.$showErrorToast(e.response.data.message)
      })
    },
    logout () {
      this.loading = true
      userLogout().then(async () => {
        await this.$router.push('/login')
        localStorage.clear()
        await this.$store.dispatch('profile/desctructor')
        this.loading = false
      }).catch(e => {
        this.loading = false
        console.error(e.response)
        // @ts-ignore
        this.$showErrorToast(e.response.data.message)
      })
    }
  },
  validations: {
    password: {
      minLength: minLength(6)
    },
    passwordConfirmation: {
      sameAsPassword: sameAs('password')
    },
    editUser: {
      name: {
        required
      },
      email: {
        email
      },
      phone: {
        required,
        minLength: minLength(12)
      }
    }
  }
})
